export const CONTENT_FETCH = "CONTENT_FETCH";
export const CONTENT_UPDATE = "CONTENT_UPDATE";
export const CONTENT_SET = "CONTENT_SET";
export const CONTENT_STATUS = "CONTENT_STATUS";
